import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ad6039d4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ad6039d4&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=ad6039d4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6039d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad6039d4')) {
      api.createRecord('ad6039d4', component.options)
    } else {
      api.reload('ad6039d4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ad6039d4&scoped=true", function () {
      api.rerender('ad6039d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/news/index.vue"
export default component.exports